module.exports = __webpack_public_path__ + "img/sld_mfm_invs_10_dark.998e61f5.svg";